import PropTypes from 'prop-types';
import {Step, StepButton, StepLabel, Stepper} from '@mui/material';
import CustomizeStepIcon from './CustomizeStepIcon';
import CustomizeConnector from './CustomizeConnector';
import {FmlxTooltip} from 'fmlx-common-ui';
import './FmlxStepper.scss';
import {FMLX_TOOLTIP} from '../../const/FmlxComponentEnum';

const FmlxStepper = ({items, activeStep, onClick, id}) => {
  const handleClick = (index) => () => {
    onClick(index);
  };

  return (
    <div id={id} className="fmlx-stepper">
      <Stepper nonLinear alternativeLabel activeStep={activeStep} connector={<CustomizeConnector/>}>
        {
          items.map((item, index) => (
            <Step id={`${id}-item-${item.title}`} key={item.id} disabled={item.disabled} completed={item.completed}>
              <StepButton onClick={handleClick(index)} id={`${id}-item-button-${item.title}`} disableRipple>
                <StepLabel
                  StepIconComponent={CustomizeStepIcon}
                  StepIconProps={{
                    icon: (item.icon ? item.icon : index + 1),
                    error: item.error,
                  }}
                >
                  <FmlxTooltip title={item.title} placement={FMLX_TOOLTIP.PLACEMENT.TOP}>
                    <div
                      className={`fmlx-stepper__title ${activeStep === index ? 'fmlx-stepper__title--active' : ''} ${item.error ? 'fmlx-stepper__title--error' : ''}`}>
                      {!item.isCompleted ? (<span className='text-red-3'>*</span>) : (<></>)}
                      {item.title}
                    </div>
                  </FmlxTooltip>
                  {item.desc && (
                    <FmlxTooltip title={item.desc} placement={FMLX_TOOLTIP.PLACEMENT.BOTTOM}>
                      <div
                        className={`fmlx-stepper__desc ${activeStep === index ? 'fmlx-stepper__desc--active' : ''} ${item.error ? 'fmlx-stepper__desc--error' : ''}`}>
                        {item.desc}
                      </div>
                    </FmlxTooltip>
                  )}
                </StepLabel>
              </StepButton>
            </Step>
          ))
        }
      </Stepper>
    </div>
  );
};

FmlxStepper.propTypes = {
  items: PropTypes.array,
  activeStep: PropTypes.number,
  onClick: PropTypes.func,
  id: PropTypes.string,
};

FmlxStepper.defaultProps = {
  items: [],
  activeStep: -1,
  onClick: () => {
  },
  id: 'fmlx-stepper',
};

export default FmlxStepper;
